import { InjectionToken, Provider, inject } from '@angular/core';
import { ConfigService } from '../../config';
import { AuthServiceBase } from './auth-service-base.model';
import { AuthService } from './auth.service';
import { HeadlessAuthService } from './headless-auth.service';
const AUTH_SERVICE_TOKEN = new InjectionToken<AuthServiceBase>('AuthService');

export function provideAuthService(): Provider {
  return {
    provide: AUTH_SERVICE_TOKEN,
    useFactory: (configService: ConfigService) => {
      if (configService.configuration.IS_HEADLESS_BROWSER) {
        return new HeadlessAuthService();
      }
      return new AuthService();
    },
    deps: [ConfigService],
  };
}

export function injectAuthService() {
  return inject(AUTH_SERVICE_TOKEN);
}
